// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.d-flex[data-v-1f7cd5d4] {\r\n  flex-wrap: wrap;\n}\n.gap-2[data-v-1f7cd5d4] {\r\n  gap: 0.5rem;\n}\r\n", ""]);
// Exports
module.exports = exports;
